// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 143) return "app-v2-b271839e.css";
	// return url for filenames based on template
	return "" + ({"271":"playground","519":"canvas"}[chunkId] || chunkId) + "-v2-" + {"271":"7f409e49","519":"7f409e49","841":"36a3d748"}[chunkId] + ".chunk.css";
};